import { render, staticRenderFns } from "./ForestGrowth.vue?vue&type=template&id=9e8e7f06&scoped=true"
import script from "./ForestGrowth.vue?vue&type=script&lang=js"
export * from "./ForestGrowth.vue?vue&type=script&lang=js"
import style0 from "./ForestGrowth.vue?vue&type=style&index=0&id=9e8e7f06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8e7f06",
  null
  
)

export default component.exports